import React from 'react';

export const EmptyCarouselContent = ({ i18n, consultationLink } : {
  i18n: {
    getString: (key: string) => string;
  };
  consultationLink: string;
}) => (
  <div className="carousel__tip_content empty_content">
    <div className="tip_image_container">
      <div className="tip_image optiConsult_tip_img" />
    </div>
    <div className="tip_text_content">
      <h1 className="tip_title">{i18n.getString(_TL_('Keep up the good work!'))}</h1>
      <div className="tip_description__wrapper">
        <h3 id="dashboardRecommendationsCardOptimizationConsultationDesc" className="tip_description">
          {i18n.getString(_TL_('At this current time, there are no more recommendations here for you to utilize. In the meantime, we’d be happy to set you up with a consultant to further optimize your campaigns.'))}
        </h3>
      </div>
      <div className="tip_links">
        <span className="tip_clickLink" data-id="0" role="presentation" tabIndex={-1}>
          <a
            className="linkButton btn-default btn"
            href={consultationLink}
            target="_blank"
            aria-labelledby="dashboardRecommendationsCardOptimizationConsultationDesc"
            rel="noreferrer"
          >
            {i18n.getString(_TL_('Learn more'))}
          </a>
        </span>
      </div>
    </div>
  </div>
);
